import { generatePath, Navigate } from "react-router";

import type { VoucherForCampaignListByHotelIdQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { CampaignListTableRoot } from "./table/root";
import { useInitialize } from "../model/usecase/use-init";

type Props = {
	hotelID: string;
	data: VoucherForCampaignListByHotelIdQuery;
};

export const MarketingCampaignTopPresenter = ({ hotelID, data }: Props) => {
	const { voucherForCampaignList, onDeleteVoucher, navigateToCreateNewCampaignPage, navigateToEditOrDetailsPage } =
		useInitialize({ hotelID, data });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<CampaignListTableRoot
			voucherForCampaignList={voucherForCampaignList}
			navigateToCreateNewCampaignPage={navigateToCreateNewCampaignPage}
			navigateToEditOrDetailsPage={navigateToEditOrDetailsPage}
			onDeleteVoucher={onDeleteVoucher}
		/>
	);
};

MarketingCampaignTopPresenter.displayName = "MarketingCampaignTopPresenter";
